import type { FC } from "react";
import {
  SelectFlatFundingMethodSlot,
  type FlatFundingPick,
  type SelectFlatFundingMethodSlotProps,
} from "../SelectFlatFundingMethodSlot";

export type { FlatFundingPick };

export type SelectFundingMethodSlotProps = Omit<
  SelectFlatFundingMethodSlotProps,
  "ns"
>;

/** Fund-request gallery: one-popup funding picker with ineligible saved cards greyed out. */
export const SelectFundingMethodSlot: FC<SelectFundingMethodSlotProps> = (
  props
) => <SelectFlatFundingMethodSlot ns="fund-request" {...props} />;
